export const TermsAndConditionsConstants = {
  sectionHeading: 20,
  minimumLength: 0,
  videoDescription: 50,
  imageDescription: 50,
  termsAndConditionsDisplayName: 50,
  description: 100000,
};
